import React, { Fragment } from "react";
import { injectIntl } from "react-intl";
import { withTheme } from "styled-components";
import { useRemoteVideoTileState } from "amazon-chime-sdk-component-library-react";
import NoCamera from "./noCamera";
import VideoTile from "./videoTile";
import MeBlock from "./meBlock";

const FullscreenTiles = withTheme(
  injectIntl(({ intl, noCameras, theme }) => {
    const { tiles } = useRemoteVideoTileState();

    const NoCameraBlocks = () => {
      let blocks = [];
      for (let item of noCameras) {
        blocks.push(<NoCamera key={item} attendee={item} />);
      }
      return blocks;
    };

    const NonFeaturedVideos = () => {
      let blocks = [];
      for (let item of tiles) {
        blocks.push(<VideoTile key={`tile${item}`} tile={item} />);
      }
      return blocks;
    };

    return (
      <Fragment>
        {NonFeaturedVideos()}
        {NoCameraBlocks()}
        <MeBlock noCameras={noCameras} />
      </Fragment>
    );
  })
);

export default FullscreenTiles;
